<template lang="pug">
nav.navbar.navbar-primary.navbar-transparent-.navbar-absolute
  //ed-meta-nav
  .container-fluid
    .navbar-header
      button.navbar-toggle(type='button', data-toggle='collapse', @click='toggleSideBar')
        span.sr-only Toggle navigation
        span.icon-bar
        span.icon-bar
        span.icon-bar
      a.navbar-brand.logo(href='#/home')
        img(src='~images/../logo.svg', height='35' v-if='!config.namespace')
        p(v-if='config.title') {{ $t(config.title) }}
    .collapse.navbar-collapse.text-right
      site-map
      //navbar-right(v-if='!config.namespace')
      //navbar-search
</template>
<script>

import SiteMap from '@/core/site-map'

import NavbarSearch from './navbar-search'
import NavbarRight from './navbar-right'

export default {
  data() {
    return {
      config: global.config
    }
  },
  computed: {
    checkLogin() {
      return this.$store.state.isLoggedIn
    }
  },
  components: {
    SiteMap,
    NavbarSearch,
    NavbarRight
  },
  methods: {
    toggleSideBar() {
      this.$emit('toggleSideBar')
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?06b40cf3